const ledgerStorageKey = 'ledger';

interface LedgerInfo {
  publicKey: string;
  index: number;
}

export const getLedgerStorage = () => ({
  getLedgerInfo: (): LedgerInfo | undefined => {
    const storageInfo = localStorage.getItem(ledgerStorageKey);

    return storageInfo && JSON.parse(storageInfo);
  },
  setLedgerInfo: (token: LedgerInfo) =>
    localStorage.setItem(ledgerStorageKey, JSON.stringify(token)),
  clearLedgerInfo: () => localStorage.removeItem(ledgerStorageKey),
});
